import { useSyncExternalStore } from "react";

const getSnapshot = () => {
  return false;
};

const getServerSnapshot = () => {
  return true;
};

const subscribe = () => {
  return () => {};
};

export const useIsSsr = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
